module.exports = __webpack_public_path__ + "static/media/washington.bcf4e6f3.png";